import { render, staticRenderFns } from "./ShiftWashJournalForm.vue?vue&type=template&id=2faca3ea&"
import script from "./ShiftWashJournalForm.vue?vue&type=script&lang=ts&"
export * from "./ShiftWashJournalForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports